import React from 'react'

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import { useHistory } from 'react-router-dom'
// core components
import GridContainer from 'components/Grid/GridContainer.js'
import GridItem from 'components/Grid/GridItem.js'

import styles from 'assets/jss/material-dashboard-pro-react/views/errorPageStyles.js'
import { ReactComponent as NotFound } from 'assets/img/404.svg'
const useStyles = makeStyles(styles)

export default function ErrorPage() {
  const classes = useStyles()
  const history = useHistory()
  return (
    <div className={classes.contentCenter}>
      <GridContainer>
        <GridItem md={12}>
          <NotFound style={{ width: '25rem', height: '20rem' }} />
          <h4 className={classes.description}>
            Ooooups! Looks like you got lost.
          </h4>
          <Button
            onClick={() => history.push(`/invoices-ai/supplierException`)}
            color="primary"
            type="button"
            variant="outlined"
            className={classes.btnColorPrimary}
            style={{ marginRight: '5px' }}
          >
            RETURN LOGIN PAGE
          </Button>
        </GridItem>
      </GridContainer>
    </div>
  )
}
